export default "__VITE_ASSET__BN3FCGt0__"